// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ProposalFragment } from '../../../modules/proposal/graphql/ProposalFragment.generated';
import { gql } from '@apollo/client';
import { ProposalFragmentDoc } from '../../../modules/proposal/graphql/ProposalFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityFragmentForProposalBuilderFragment = { __typename?: 'Entity', id: string, stage: Types.EntityStage, gratTrust?: { __typename?: 'GRATTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, tenantID: string, taxableGift?: CurrencyUSD | null, currentValue: CurrencyUSD, displayName: string, legalName?: string | null, rollingPeriodYears?: number | null, termDurationYears?: number | null, assetSummaryDisplay?: string | null, annuityAnnualIncreasePercent?: Percent | null, officialInterestRatePercent?: Percent | null, targetTaxableGift?: CurrencyUSD | null, projectedSharePrice?: CurrencyUSD | null, projectedRateOfReturn?: Percent | null, projectedMarketValue?: CurrencyUSD | null, gratSummaryDisplay?: string | null, grantorRetainedInterest: CurrencyUSD, annuities?: Array<{ __typename?: 'GRATAnnuityV2', id: string }> | null, designerAccount?: { __typename?: 'Account', id: string, displayName: string, initialValuation?: { __typename?: 'AssetValuationV2', id: string, fixedValuationAmount?: CurrencyUSD | null, description?: string | null } | null } | null, grantor?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string, legalName: string, displayName: string } | null } | null, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null }> | null } | null };

export type ProposalBuilderPageQueryQueryVariables = Types.Exact<{
  proposalWhereInput?: Types.InputMaybe<Types.ProposalWhereInput>;
  entityWhereInput?: Types.InputMaybe<Types.EntityWhereInput>;
}>;


export type ProposalBuilderPageQueryQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EntityFragmentForProposalBuilderFragment
      ) | null } | null> | null }, proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: (
        { __typename?: 'Proposal' }
        & ProposalFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ProposalBuilderPageQuery: 'ProposalBuilderPageQuery' as const
  },
  Fragment: {
    EntityFragmentForProposalBuilder: 'EntityFragmentForProposalBuilder' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityFragmentForProposalBuilderFragmentDoc = gql`
    fragment EntityFragmentForProposalBuilder on Entity {
  id
  stage
  gratTrust {
    id
    taxStatus
    tenantID
    taxableGift
    currentValue
    displayName
    legalName
    rollingPeriodYears
    termDurationYears
    assetSummaryDisplay
    annuityAnnualIncreasePercent
    officialInterestRatePercent
    annuities {
      id
    }
    designerAccount {
      id
      initialValuation {
        id
        fixedValuationAmount
        description
      }
      displayName
    }
    targetTaxableGift
    projectedSharePrice
    projectedRateOfReturn
    projectedMarketValue
    gratSummaryDisplay
    grantorRetainedInterest
    grantor {
      id
      individual {
        id
        legalName
        displayName
      }
    }
    beneficiaries {
      id
      individual {
        id
      }
      entity {
        id
      }
    }
  }
}
    `;
export const ProposalBuilderPageQueryDocument = gql`
    query ProposalBuilderPageQuery($proposalWhereInput: ProposalWhereInput, $entityWhereInput: EntityWhereInput) {
  entities(where: $entityWhereInput) {
    edges {
      node {
        ...EntityFragmentForProposalBuilder
      }
    }
  }
  proposals(where: $proposalWhereInput) {
    edges {
      node {
        ...Proposal
      }
    }
  }
}
    ${EntityFragmentForProposalBuilderFragmentDoc}
${ProposalFragmentDoc}`;

/**
 * __useProposalBuilderPageQueryQuery__
 *
 * To run a query within a React component, call `useProposalBuilderPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalBuilderPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalBuilderPageQueryQuery({
 *   variables: {
 *      proposalWhereInput: // value for 'proposalWhereInput'
 *      entityWhereInput: // value for 'entityWhereInput'
 *   },
 * });
 */
export function useProposalBuilderPageQueryQuery(baseOptions?: Apollo.QueryHookOptions<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>(ProposalBuilderPageQueryDocument, withFetchPolicyContext(options));
      }
export function useProposalBuilderPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>(ProposalBuilderPageQueryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useProposalBuilderPageQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>(ProposalBuilderPageQueryDocument, withFetchPolicyContext(options));
        }
export type ProposalBuilderPageQueryQueryHookResult = ReturnType<typeof useProposalBuilderPageQueryQuery>;
export type ProposalBuilderPageQueryLazyQueryHookResult = ReturnType<typeof useProposalBuilderPageQueryLazyQuery>;
export type ProposalBuilderPageQuerySuspenseQueryHookResult = ReturnType<typeof useProposalBuilderPageQuerySuspenseQuery>;
export type ProposalBuilderPageQueryQueryResult = Apollo.QueryResult<ProposalBuilderPageQueryQuery, ProposalBuilderPageQueryQueryVariables>;